import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getAllPeople = (payload) => {
    return vdkEmHappinessPortalApi.post('people/get-all', payload);
};
const getPersonById = (personId) => {
    return vdkEmHappinessPortalApi.get(`/people/${personId}`);
};
const getAllPeopleForTasksWithoutPagination = () => {
    return vdkEmHappinessPortalApi.post('/people/get-all-people-for-tasks-without-pagination', {});
};
const getAllPeopleWithoutPagination = (eventId, searchString) => {
    return vdkEmHappinessPortalApi.post('people/get-all-without-pagination', {
        pageNumber: 1,
        pageSize: 10,
        eventId,
        searchString
    });
};
const getReferredByPersonByMvpId = (mvpId) => {
    return vdkEmHappinessPortalApi.post('/mvps/get-referred-by-person', { mvpId });
};
const getAllPeopleRecentEvents = (payload) => {
    return vdkEmHappinessPortalApi.post('people/people-recent-events/get-all', payload);
};
const exportPeopleToExcel = (payload) => {
    return vdkEmHappinessPortalApi.post('people/export-excel', payload, { responseType: 'blob' });
};
const peopleAPI = {
    getAllPeople,
    getPersonById,
    getAllPeopleForTasksWithoutPagination,
    getAllPeopleWithoutPagination,
    getReferredByPersonByMvpId,
    getAllPeopleRecentEvents,
    exportPeopleToExcel
};
export default peopleAPI;
